if (!customElements.get("pickup-availability")) {
  customElements.define(
    "pickup-availability",
    class PickupAvailability extends HTMLElement {
      constructor() {
        super();

        // Prepared before the early return: a variant switch can fetch into an element rendered without `available`.
        this.errorHtml =
          this.querySelector("template")?.content.firstElementChild.cloneNode(
            true
          );
        this.onClickRefreshList = this.onClickRefreshList.bind(this);

        if (!this.hasAttribute("available")) return;

        this.fetchAvailability(this.dataset.variantId);
      }

      fetchAvailability(variantId) {
        const variantSectionUrl = `${this.dataset.baseUrl}variants/${variantId}/?section_id=pickup-availability`;

        fetch(variantSectionUrl)
          .then((response) => response.text())
          .then((text) => {
            const sectionInnerHTML = new DOMParser()
              .parseFromString(text, "text/html")
              .querySelector(".shopify-section");
            this.renderPreview(sectionInnerHTML);
          })
          .catch((e) => {
            const refreshBtn = this.querySelector(
              ".pickup-availability-refresh"
            );
            refreshBtn?.removeEventListener("click", this.onClickRefreshList);
            this.renderError();
          });
      }

      onClickRefreshList(event) {
        this.fetchAvailability(this.dataset.variantId);
      }

      renderError() {
        this.innerHTML = "";
        this.appendChild(this.errorHtml);

        const refreshBtn = this.querySelector(".pickup-availability-refresh");
        refreshBtn?.addEventListener("click", this.onClickRefreshList);
      }

      renderPreview(sectionInnerHTML) {
        const sectionId = this.dataset.section || this.dataset.variantId;
        const drawerId = `PickupAvailabilityDrawer-${sectionId}`;
        const drawer = document.getElementById(drawerId);
        if (drawer) drawer.remove();
        if (!sectionInnerHTML.querySelector("pickup-availability-preview")) {
          this.innerHTML = "";
          this.removeAttribute("available");
          return;
        }

        this.innerHTML = sectionInnerHTML.querySelector(
          "pickup-availability-preview"
        ).outerHTML;
        this.setAttribute("available", "");

        const newDrawer = sectionInnerHTML.querySelector(
          "pickup-availability-drawer"
        );
        if (newDrawer) {
          newDrawer.id = drawerId;
          document.body.appendChild(newDrawer);
        }

        this.querySelector("button")?.addEventListener("click", (e) => {
          document.getElementById(drawerId)?.show(e.target);
        });
      }
    }
  );
}

if (!customElements.get("pickup-availability-drawer")) {
  customElements.define(
    "pickup-availability-drawer",
    class PickupAvailabilityDrawer extends HTMLElement {
      constructor() {
        super();

        const closeElementsSelectors = [
          ".pickup-availability-drawer-close",
          ".pickup-availability-overlay",
        ];

        this.querySelectorAll(closeElementsSelectors).forEach((closeEl) => {
          closeEl.addEventListener("click", () => {
            this.hide();
          });
        });

        this.addEventListener("keyup", (event) => {
          if (event.code.toUpperCase() === "ESCAPE") this.hide();
        });
      }

      hide() {
        this.removeAttribute("open");
        document.body.classList.remove("overflow-hidden");
        removeTrapFocus(this.focusElement);
      }

      show(focusElement) {
        this.focusElement = focusElement;
        this.setAttribute("open", "");
        document.body.classList.add("overflow-hidden");

        this.addEventListener(
          "transitionend",
          () => {
            trapFocus(this, this.querySelector('[role="dialog"]'));
          },
          { once: true }
        );
      }
    }
  );
}
